import { TAU } from './const';

/**
 * The circumference of a circle is the perimeter of the circle.
 * It is the total length of the boundary of the circle.
 *
 * @param radius Radius of the circle.
 * @returns Returns the circumference of a circle.
 * @example
 *
 * circumference(1)
 * // => 6.28319
 *
 * circumference(25)
 * // => 157.07963
 */
export function circumference(radius: number): number {
  return TAU * radius;
}
